import { NgModule } from '@angular/core';
import { AdminRouting } from './admin-routing.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'src/app/shared/shared.module';
import { AdminControlVehiculos } from './control-vehiculos/control-vehiculos.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { ControlVehiculosGeocerca } from './control-vehiculos-geocerca/control-vehiculos-geocerca.component';
import { ControlVehiculosEventos } from './control-vehiculos-eventos/control-vehiculos-eventos.component';
import { ControlVehiculosMovimiento } from './control-vehiculos-movimiento/control-vehiculos-movimiento.component';
import { ControlVehiculosMantenimiento } from './control-vehiculos-mantenimiento/control-vehiculos-mantenimiento.component';
import { ControlVehiculosLista } from './control-vehiculos-listavehiculos/control-vehiculos-listavehiculos.component';
import { ControlVehiculosSinTransmitir } from './control-vehiculos-sintransmitir/control-vehiculos-sintransmitir.component';
import { ControlVehiculosRutas } from './control-vehiculos-rutas/control-vehiculos-rutas.component';
import { ControlVehiculosRutasAdd } from './control-vehiculos-rutas-add/control-vehiculos-rutas-add.component';
//import { ControlPuntosComponent } from './control-puntos/control-puntos.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { ContactosComponent } from './contact/contactos/contactos.component';

import { GrupoReferenciaComponent } from './grupos-referencias/grupo-referencia.component';
import { GruposReferenciasTablaComponent } from './grupos-referencias-tabla/grupos-referencias-tabla.component';
import { ArchivoRoadshowComponent } from './archivo-roadshow/archivo-roadshow.component';
import { ImportarPuntosComponent } from './importar-puntos/importar-puntos.component';
import { ImportarGpxComponent } from './importar-gpx/importar-gpx.component';

import { CuentaComponent } from './cuenta/cuenta.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { UsuariosRoadshowComponent } from './usuarios-roadshow/usuarios-roadshow.component';
import { SupervisoresComponent } from './supervisores/supervisores.component';
import { MotivosNoEntregaComponent } from './motivos-no-entrega/motivos-no-entrega.component';
import { GruposComponent } from './grupos/grupos.component';
import { GrupoFormComponent } from './grupo-form/grupo-form.component';
import { GrupoUsuariosComponent } from './grupo-usuarios/grupo-usuarios.component';
import { GrupoVehiculosComponent } from './grupo-vehiculos/grupo-vehiculos.component';
import { ChoferesComponent } from './choferes/choferes.component';
import { AccesosAlSistemaComponent } from './accesos-al-sistema/accesos-al-sistema.component';
import { InformesPericialesComponent } from './informes-periciales/informes-periciales.component';
import { UsuariosTablaComponent } from './usuarios-tabla/usuarios-tabla.component';
import { UsuariosRoadshowTablaComponent } from './usuarios-roadshow-tabla/usuarios-roadshow-tabla.component';
import { SupervisoresTablaComponent } from './supervisores-tabla/supervisores-tabla.component';
import { MotivosNoEntregaTablaComponent } from './motivos-no-entrega-tabla/motivos-no-entrega-tabla.component';
import { ChoferesTablaComponent } from './choferes-tabla/choferes-tabla.component';
import { ControlVehiculosDestinatarios } from './control-vehiculos-destinatarios/control-vehiculos-destinatarios.component';

@NgModule({
    declarations: [
        AdminControlVehiculos,
        ControlVehiculosGeocerca,
        ControlVehiculosEventos,
        ControlVehiculosMovimiento,
        ControlVehiculosMantenimiento,
        ControlVehiculosLista,
        ControlVehiculosSinTransmitir,
        ControlVehiculosRutas,
        ControlVehiculosRutasAdd,
        //ControlPuntosComponent,
        UpgradeComponent,
        ContactosComponent,

        GrupoReferenciaComponent,
        GruposReferenciasTablaComponent,
        ArchivoRoadshowComponent,
        ImportarPuntosComponent,
        ImportarGpxComponent,

        CuentaComponent,
        UsuariosComponent,
        UsuariosRoadshowComponent,
        SupervisoresComponent,
        MotivosNoEntregaComponent,
        GruposComponent,
        GrupoFormComponent,
        GrupoUsuariosComponent,
        GrupoVehiculosComponent,
        ChoferesComponent,
        AccesosAlSistemaComponent,
        InformesPericialesComponent,
        UsuariosTablaComponent,
        UsuariosRoadshowTablaComponent,
        SupervisoresTablaComponent,
        MotivosNoEntregaTablaComponent,
        ChoferesTablaComponent,
        ControlVehiculosDestinatarios,
    ],
    imports: [
        InlineSVGModule.forRoot(),
        AdminRouting,
        ScrollingModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        AccesosAlSistemaComponent,
        GruposReferenciasTablaComponent
    ]
})

export class AdminModule { }
